import React from 'react';
import './AISection.css';

const principles = [
    {
        title: 'You own what AI creates',
        desc: 'Review it, understand it, be responsible for it. "AI wrote it" is never an excuse.',
    },
    {
        title: 'Protect customer data',
        desc: 'Never paste customer or production data into AI tools. Treat every prompt as a public conversation.',
    },
    {
        title: 'Think better — not less',
        desc: 'Use AI to go faster, not to go shallow. It does not replace product judgment or real customer conversations.',
    },
    {
        title: 'Share what works',
        desc: 'Found a prompt or workflow that helps? Share it. We learn faster together than alone.',
    },
];

const roles = [
    {
        image: 'img/productmanager.svg',
        label: 'Product Manager',
        bullets: [
            'Synthesise interview notes and identify patterns',
            'Generate and stress-test hypotheses',
            'Draft opportunity statements and problem framings',
            'Analyse customer feedback at scale',
        ],
    },
    {
        image: 'img/uxdesigner.svg',
        label: 'UX Designer',
        bullets: [
            'Explore many concepts quickly before committing',
            'Generate and test copy and microcopy variants',
            'Run accessibility checks on designs',
            'Create quick prototypes to validate ideas',
        ],
    },
    {
        image: 'img/developer.svg',
        label: 'Developer',
        bullets: [
            'Code generation, completion and refactoring',
            'Write and extend automated tests',
            'Explain and review unfamiliar code',
            'Generate documentation from code',
        ],
    },
    {
        image: 'img/productspecialist.svg',
        label: 'Product Specialist',
        bullets: [
            'Synthesise support tickets to find patterns',
            'Draft help articles and documentation',
            'Prepare customer communication',
            'Research domain-specific questions quickly',
        ],
    },
];

function AISection() {
    return (
        <div className="container">
            <div className="ai-section">

                {/* Intro block */}
                <div className="ai-intro">
                    <h1 className="ai-title">Working with AI</h1>
                    <p className="ai-lead">
                        AI makes execution cheaper — which means discovery becomes <em>more</em> important,
                        not less. Use it to move faster, but never to skip thinking.
                    </p>
                </div>

                {/* Block 1: Four principle cards */}
                <div className="ai-principles-block">
                    <h2 className="ai-block-heading">How we work with AI</h2>
                    <div className="ai-principles-grid">
                        {principles.map((p) => (
                            <div className="ai-principle-card" key={p.title}>
                                <h3 className="ai-principle-title">{p.title}</h3>
                                <p className="ai-principle-desc">{p.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Block 2: Roles */}
                <div className="ai-roles-block">
                    <h2 className="ai-block-heading">AI across the team</h2>
                    <div className="ai-roles-grid">
                        {roles.map((role) => (
                            <div className="ai-role-card" key={role.label}>
                                <div className="ai-role-card-header">
                                    <img
                                        src={role.image}
                                        alt={role.label}
                                        className="ai-role-img"
                                    />
                                    <h3 className="ai-role-label">{role.label}</h3>
                                </div>
                                <div className="ai-role-card-body">
                                    <ul>
                                        {role.bullets.map((bullet) => (
                                            <li key={bullet}>{bullet}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default AISection;
